import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import ProjectService from "../services/ProjectService";
import DailyFuelEntryService from "../services/DailyFuelEntryService";
import StorageService from "../services/StorageService";
import { configSettings } from "../config/configSettings";
import Loading from "../components/loading";
import ReactPaginate from "react-paginate";
import XLSX from "xlsx-js-style";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import MessageDialog from "../components/MessageDialog";
import utility from "../utils/utility";


export default function ViewDailyFuelEntry() {
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [entries, setEntries] = useState([]);
  const [filteredEntries, setFilteredEntries] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [msgType, setMsgType] = useState("error");
  const [pageCount, setPageCount] = useState(0);
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 20;

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  // const messageTimer = useRef(null);
  const emp = StorageService.loginData();
  const isSuperAdmin =
    emp.roleName === "Super Admin" ||
    emp.roleName === "SuperAdmin" ||
    emp.roleName === "Data Admin" ||
    emp.roleName === "DataAdmin" ||
    Number(emp.roleId) === 1 ||
    Number(emp.roleId) === 2;

  /* ===============================
     LOAD PROJECTS
     =============================== */
  // useEffect(() => {
  //   loadProjects();
  //   loadAllEntries();
  // }, [currentPage]);

  const showMessage = (msg) => {
    setMessage(msg);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 3000);
  };

  const { permission, checkView, can } = usePermission(
  ScreenData.Daily_Fuel_Entry,
  showMessage
  );

  const loadProjects = async () => {
    try {
      const comp = StorageService.activeCompany();
      const emp = StorageService.loginData();

      let projectsData = [];

      if (
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        emp.roleName === "DataAdmin" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2
      ) {
        const res = await ProjectService.getActive(comp.companyId);
        projectsData = (res || []).map(p => ({
          id: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode
        }));
      } else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );
        projectsData = (res?.data?.data || []).map(p => ({
          id: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode
        }));
      }

      setProjects(projectsData);
    } catch (err) {
      console.error(err);
      setProjects([]);
    }
  };

  /* ===============================
     LOAD ALL DAILY FUEL ENTRIES (ON PAGE LOAD)
     =============================== */
  const loadAllEntries = async () => {
    setLoading(true);
    try {
      const comp = StorageService.activeCompany();
      const emp = StorageService.loginData();

      // const all = await DailyFuelEntryService.getAll();
      // const entryList = all || [];

const res = await DailyFuelEntryService.getAll(
  currentPage,
  itemsPerPage
);

const entryList = res?.data || [];

setPageCount(res?.totalPages || 0);

      let allowedProjectIds = [];

      if (
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        emp.roleName === "DataAdmin" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2
      ) {
        // SUPER ADMIN → ALL COMPANY PROJECTS
        const projRes = await ProjectService.getActive(comp.companyId);
        allowedProjectIds = (projRes || []).map(p => Number(p.id));
      } else {
        // NORMAL USER → ONLY ASSIGNED PROJECTS
        const projRes = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        allowedProjectIds = (projRes?.data?.data || []).map(p =>
          Number(p.projectId || p.id)
        );
      }

      // FILTER ENTRIES BASED ON ALLOWED PROJECTS
      const allowedEntries = entryList
        .filter((e) => allowedProjectIds.includes(Number(e.projectId)))
        .sort(
          (a, b) =>
            new Date(b.fuelEntryDate || 0) - new Date(a.fuelEntryDate || 0) ||
            (b.id || 0) - (a.id || 0)
        );

      setEntries(allowedEntries);
      setFilteredEntries(allowedEntries);

      // VEHICLE DROPDOWN (FROM ALLOWED DATA ONLY)
      const uniqueVehicles = [
        ...new Map(
          allowedEntries.map(e => [
            e.vehicleId,
            { id: e.vehicleId, name: e.vehicleName },
          ])
        ).values(),
      ];

      setVehicles(uniqueVehicles);
    } catch (err) {
      console.error(err);
      setEntries([]);
      setFilteredEntries([]);
      setVehicles([]);
    } finally {
      setLoading(false);
    }
  };

  const loadLiveFilteredData = async () => {
    try {
      const comp = StorageService.activeCompany();
      const emp = StorageService.loginData();

      // If nothing selected → fallback to local filtering
      if (
        !selectedProjectId &&
        !selectedVehicle &&
        !fromDate &&
        !toDate
      ) {
        setFilteredEntries(entries);
        return;
      }

      const data = await DailyFuelEntryService.searchByDate({
        companyId: comp.companyId,
        employeeId: emp.employeeId,
        projectId: selectedProjectId,
        vehicleId: selectedVehicle,
        fromDate,
        toDate,
      });

      setFilteredEntries(data || []);
    } catch (err) {
      console.error(err);
      setFilteredEntries([]);
    }
  };

  useEffect(() => {
    if (permission && checkView()) {
      loadLiveFilteredData();
    }
  }, [selectedProjectId, selectedVehicle, fromDate, toDate, permission]);



  const exportExcel = async () => {
    if (!can("canView")) {
      showMessage("No permission");
      return;
    }
  try {
    const company = StorageService.activeCompany();

    const res = await DailyFuelEntryService.exportFuelEntry(
      company.companyId
    );

    if (!res?.status || !res.data.length) {
      showMessage("No data to export", "error");
      return;
    }

    const fuelEntries = res.data;

    const wb = XLSX.utils.book_new();
    const ws = {};
    ws["!merges"] = [];

    let row = 0;

    // ✅ STYLES
    const thin = { style: "thin" };
    const thick = { style: "medium" };

    const center = {
      horizontal: "center",
      vertical: "center",
      wrapText: true
    };

    /* ================= TITLE ================= */
    XLSX.utils.sheet_add_aoa(ws, [["Daily Fuel Entry Report"]], {
      origin: { r: row, c: 1 }
    });

    ws["!merges"].push({
      s: { r: row, c: 1 },
      e: { r: row, c: 11 }
    });

    const titleCell = XLSX.utils.encode_cell({ r: row, c: 1 });

    ws[titleCell].s = {
      font: { bold: true, sz: 16 },
      alignment: center
    };

    row += 2;

    /* ================= HEADER ================= */
    const header = [
      "Project",
      "Vehicle",
      "Registration No",
      "Fuel Vendor",
      "Vendor Category",
      "Date",
      "Voucher No",
      "Amount",
      "Reading",
      "Status"
    ];

    const startRow = row; // ✅ TRACK START

    XLSX.utils.sheet_add_aoa(ws, [header], {
      origin: { r: row, c: 1 }
    });

    header.forEach((_, i) => {
      const cell = XLSX.utils.encode_cell({ r: row, c: i + 1 });

      ws[cell].s = {
        font: { bold: true },
        alignment: center
      };
    });

    row++;

    /* ================= DATA ================= */
    fuelEntries.forEach((f) => {
      const rowData = [
        `${f.projectName || ""}-${f.projectCode || ""}`,
        f.vehicleName || "",
        f.registrationNo || "",
        f.fuelVendorName || "",
        f.vendorCategoryName || "",
        utility.formatDateDDMMMYYYY(f.fuelEntryDate),
        f.vocherNo || "",
        f.amount || 0,
        f.fromReading || "",
        f.status || ""
      ];

      XLSX.utils.sheet_add_aoa(ws, [rowData], {
        origin: { r: row, c: 1 }
      });

      row++;
    });

    const endRow = row - 1; // ✅ TRACK END

    /* ================= APPLY BORDERS 🔥 ================= */
    const colCount = header.length;

    for (let r = startRow; r <= endRow; r++) {
      for (let c = 1; c <= colCount; c++) {
        const cell = XLSX.utils.encode_cell({ r, c });

        if (!ws[cell]) {
          ws[cell] = { t: "s", v: "" };
        }

        ws[cell].s = ws[cell].s || {};
        ws[cell].s.alignment = center;

        ws[cell].s.border = {
          top: r === startRow ? thick : thin,
          bottom: r === endRow ? thick : thin,
          left: c === 1 ? thick : thin,
          right: c === colCount ? thick : thin
        };
      }
    }

    /* ================= COLUMN WIDTH ================= */
    ws["!cols"] = [
      { wch: 25 },
      { wch: 25 },
      { wch: 18 },
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 18 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 }
    ];

    /* ================= EXPORT ================= */
    XLSX.utils.book_append_sheet(wb, ws, "FuelEntry");

    XLSX.writeFile(wb, "DailyFuelEntry.xlsx");

  } catch (error) {
    console.error(error);
   showMessage("Error exporting data", "error");
  }
};


  /* ===============================
     LIVE FILTERING (Project + Vehicle + Dates)
     =============================== */
  // useEffect(() => {
  //   let data = [...entries];

  //   if (selectedProjectId) {
  //     data = data.filter(
  //       (e) => Number(e.projectId) === Number(selectedProjectId)
  //     );
  //   }

  //   if (selectedVehicle) {
  //     data = data.filter(
  //       (e) => Number(e.vehicleId) === Number(selectedVehicle)
  //     );
  //   }

  //   if (fromDate) {
  //     data = data.filter(
  //       (e) => new Date(e.fuelEntryDate) >= new Date(fromDate)
  //     );
  //   }

  //   if (toDate) {
  //     data = data.filter(
  //       (e) => new Date(e.fuelEntryDate) <= new Date(toDate)
  //     );
  //   }


  //   setFilteredEntries(data);
  // }, [selectedProjectId, selectedVehicle, fromDate, toDate, entries]);

  useEffect(() => {
    const sum = filteredEntries.reduce((acc, e) => acc + (Number(e.amount) || 0), 0);
    setTotalAmount(sum);
  }, [filteredEntries]);
  /* ===============================
     DATE VALIDATION
     =============================== */
  const handleToDateChange = (val) => {
    if (fromDate && val && new Date(val) <= new Date(fromDate)) {
      showMessage("To Date must be greater than From Date");
      setToDate("");
      return;
    }
    setToDate(val);
  };

  /* ===============================
     MESSAGE HANDLER
     =============================== */
  

  useEffect(() => {
    if (permission) {
      if (checkView()) {
        loadProjects();
        loadAllEntries();
      }
    }
  }, [currentPage, permission]);



  const handlePageClick = (event) => {
  setCurrentPage(event.selected + 1);
  };
  
  const handleAdd = () => {
    if (!can("canAdd")) {
      showMessage("No permission");
      return;
    }
    navigate("/cpnl/dailyfuelentry/add");
  };

  /* ===============================
     STATUS TOGGLE
     =============================== */
  const toggleStatus = async (row) => {
    if (!can("canModify")) {
      showMessage("No permission");
      return;
    }
    if (!window.confirm("Change status?")) return;
    setLoading(true);
    try {
      await DailyFuelEntryService.updateStatus(row.id);
      const updated = entries.map((e) =>
        e.id === row.id
          ? { ...e, status: e.status === "Active" ? "Inactive" : "Active" }
          : e
      );
      setEntries(updated);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb pageTitle="Daily Fuel Entry" secondTitle="Fuel" />

      
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      
      <div className="card p-3 shadow-sm">

        {/* {message && <div className="alert alert-danger py-2">{message}</div>} */}

        {/* FILTERS */}
        <div className="d-flex gap-3 flex-wrap mb-3">

          {/* PROJECT */}
          <div style={{ minWidth: "280px" }}>
            <label className="form-label mb-1">Project</label>
            <Select
              options={projects.map((p) => ({
                value: String(p.id),
                label: `${p.projectName} - ${p.projectCode}`
              }))}
              value={
                selectedProjectId
                  ? {
                      value: String(selectedProjectId),
                      label: (() => {
                        const p = projects.find((x) => String(x.id) === String(selectedProjectId));
                        return p ? `${p.projectName} - ${p.projectCode}` : "";
                      })()
                    }
                  : null
              }
              onChange={(opt) => setSelectedProjectId(opt ? opt.value : "")}
              isSearchable={true}
              isClearable={true}
              placeholder="All Projects"
              classNamePrefix="react-select"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({ ...base, minHeight: "38px" })
              }}
            />
          </div>

          {/* VEHICLE */}
          <div>
            <label className="form-label">Vehicle</label>
            <select
              className="form-select"
              value={selectedVehicle}
              onChange={(e) => setSelectedVehicle(e.target.value)}
            >
              <option value="">All Vehicles</option>
              {vehicles.map((v) => (
                <option key={v.id} value={v.id}>
                  {v.name}
                </option>
              ))}
            </select>
          </div>

          {/* FROM DATE */}
          <div>
            <label className="form-label">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value);
                setToDate("");
              }}
            />
          </div>

          {/* TO DATE */}
          <div>
            <label className="form-label">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => handleToDateChange(e.target.value)}
            />
          </div>
          {/* Total Amount */}
          <div>
            <label className="form-label">Total Amount:</label>
            <input
              type="text"
              className="form-control"
              value={`₹ ${totalAmount}`}
              disabled
            />
          </div>
          {/* ADD */}
          
            <div className="ms-auto d-flex gap-2 align-self-end">

              {can("canAdd") && (
                <button
                  className="btn btn-success"
                  onClick={handleAdd}
                >
                  <i className="ti ti-plus me-1"></i> Add
                </button>
              )}

              {can("canView") && (
                <button className="btn btn-success" onClick={exportExcel}>
                  <i className="ti ti-download me-1"></i> Export Excel
                </button>
              )}

            </div>
          
        </div>

        {/* TABLE */}
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="table-light">
              <tr>
                <th>S.No</th>
                <th>Project Name</th>
                <th>Vehicle No</th>
                <th>Fuel Supplier</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Fuel Receipt</th>
              </tr>
            </thead>

            <tbody>

              {loading ? (
  <tr>
    <td colSpan="5" className="text-center py-4">
      <Loading />
    </td>
  </tr>
): filteredEntries.length ? (
                filteredEntries.map((e, idx) => (
                  <tr key={e.id}>
                    <td>{idx + 1}</td>
                    <td>{e.projectName}-{e.projectCode}</td>
                    <td>{e.vehicleName}-{e.registrationNo}</td>
                    <td>{e.fuelVendorName}</td>
                    <td>{utility.formatDateDDMMMYYYY(e.fuelEntryDate)}</td>
                    <td>₹ {e.amount}</td>
                    <td>
                      {e.fuelReceiptURL ? (
                        <a
                          href={`${configSettings.mediaURL}/get/dailyFuelEntry/${e.fuelReceiptURL}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          View
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <ReactPaginate
  breakLabel="..."
  nextLabel="Next >"
  onPageChange={handlePageClick}
  pageRangeDisplayed={3}
  marginPagesDisplayed={2}
  pageCount={pageCount}
  previousLabel="< Previous"
  containerClassName="pagination-container"
  pageClassName="page-item"
  pageLinkClassName="page-link"
  previousClassName="page-item"
  previousLinkClassName="page-link"
  nextClassName="page-item"
  nextLinkClassName="page-link"
  activeClassName="active"
/>
        </div>

      </div>
    </>
  );
}
